export const actionUserInfo = ({ commit }, userInfo) => {
  commit('actionUserInfo', userInfo)
}
export const actionAllSelect = ({ commit }, allSelect) => {
  commit('actionAllSelect', allSelect)
}
export const actionSence = ({ commit }, sence) => {
  commit('actionSence', sence)
}
export const actionToast = ({ commit }, toast) => {
  commit('actionToast', toast)
}
export const actionLoadingToast = ({ commit }, loadingToast) => {
  commit('actionLoadingToast', loadingToast)
}
